import React from 'react';
// import VentPos from './VentPos'
// import CropProtection from './CropProtection'
// import StructuralProtection from './StructuralProtection'
// import CravoSetpoint0 from './CravoSetpoint0'
import SaveCancel from './SaveCancel'
import {p, pi, pInd} from '../../components/utils/paramIds';
import {cl, globs, constant, proportionals800, leadZeros,
  getTime,getTimeI} from '../../components/utils/utils';
import {getParamId,getParamId800,getPearlUsed} from '../../usa/utils/utils';
import {sendArray, checkSendArray,dbVals} from '../../components/utils/http';
import {groupPidArrs} from '../utilsFui';

class TempStaging00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.props.getValue(props.ind, {type: "saveCancel"})
    this.state={
    }
//     cl(props.groupInfo)
    if(props.groupInfo){
      props.rest.parent({
        uri:"registerLocalSave",
        ind:props.ind,
        func:this.localSave,
      })
    }
    this.conflicts=this.checkConflicts(props.commonValues)
    this.loadInfo()
//     cl("load info done")
//     setParamIds(this)
//     this.getCravoData()
//     cl(this.state)
    this.subscribe_updateFui=globs.events.subscribe("updateFui", this.updateFui)
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",
      this.savePageEvent)
  }
  
  updateFui=()=>{
    if(!this.changed){
      this.setState({chans:this.loadStagesData()})
    }
  }

  savePageEvent=()=>{
    this.changed=false
  }

  componentWillUnmount=()=>{
    this.subscribe_updateFui.remove()
    this.subscribe_savePageEvent.remove()
  }

  getStagePids=()=>{
    // let res=getParamId800("igCE","heat2")
    // cl(res)
    // let gwType=this.gwType
    let is800=this.gwType==800
    var getPidArray=(arr)=>{
      let tab=(is800)?"igCE":"configuration_channel_data"
      // cl(tab)
      return arr.map(id=>{return (id=="")?-1:
        ((is800)?getParamId800:getParamId)(tab,id)})
    }
    let onoIds_800=["","","","","heat2","heat1","normal","cool1","cool2","cool3","cool4",
      "cool5","cool6"]
    let ventIds_800=["","","","","","","","cool1","cool2","cool3","cool4",
      "cool5","cool6"]
    let ventIds=["","","","","","","CD_normal_vent","cool_1","cool_2","cool_3","cool_4",
      "cool_5","cool_6"]
    let ventIds_1900=["","","","","","","normal_onoff","CD_cool_1","CD_cool_2",
      "CD_cool_3","CD_cool_4","CD_cool_5","CD_cool_6"]
    let onoIds=["CD_heat_6","CD_heat_5","CD_heat_4","CD_heat_3","CD_heat_2","CD_heat_1",
    "normal_onoff","CD_cool_1","CD_cool_2","CD_cool_3","CD_cool_4","CD_cool_5","CD_cool_6"]
    if(this.gwType==1900){
      ventIds=ventIds_1900
    }
    if(is800){
      ventIds=ventIds_800
      onoIds=onoIds_800
    }
    return{
      ventPids:getPidArray(ventIds),
      onoPids:getPidArray(onoIds)
    }
  }
  
//   getGatewayType=(zoneInd)=>{
// //     cl(this.zone)
// //     cl(globs.userData)
//     let siteId=globs.userData.siteLoaded
//     let zoneInfo=globs.zonesInfo.info.filter(zi=>{return(zi.siteId==siteId)&&(zi.siteZoneIndex==zoneInd)})
//     return zoneInfo[0]?.gatewayType
// //     cl(zoneInfo)
//   }

  componentDidMount() {
    // Load stage data into state first
    this.loadInfo()
   
  }

  loadStagesData=()=>{
    let pr=this.props
    let parms=[]
    // cl(pr)
//     cl(globs)
    let parts=pr.zuci.split("-")
    this.zone=+parts[0]
    let isPearl=pr.current.gwType==1900
    let is800=pr.current.gwType==800
    this.zi=(globs.zonesInfo.info.filter(zi=>{
      return(zi.siteId==globs.userData.siteLoaded)&&
      (zi.siteZoneIndex==this.zone)
    })||[])[0]
    // cl(this.zi)
    this.gwType=+this.zi.gatewayType//+this.getGatewayType(this.zone)
    // cl(this.gwType)
    let stagePids=this.getStagePids()
//     cl(stagePids)
    let pid=getParamId("configuration_zone_settings","Heat stages")
    if(dbVals.z[this.zone][255]){
      this.heatStages=((dbVals.z[this.zone][255]||{})[pid])||1
      pid=getParamId("configuration_zone_settings","Cool stages")
      this.coolStages=(+dbVals.z[this.zone][255][pid])||6
    }else{
      this.heatStages=1
      this.coolStages=6
    }
    if(is800){
      this.heatStages=2
      this.coolStages=6
    }
    let chans=[]
    var pearlUsed=[],pChans=[]
    this.ourKey=pr?.orCommonControls?.filter(k=>{
      return k.split("-")[2]=="tempStaging"})[0]
//     cl(this.ourKey)

//     let zInd=+this.zuci[0]
//     cl(pr)
    if(isPearl){
      pearlUsed=getPearlUsed(this.zone)
      pChans=Object.keys(pearlUsed).map(k=>{return pearlUsed[k].chInd})
    }
    if(is800){pChans=[...Array(8).keys()]}
    // cl(pearlUsed)
    // cl(pChans)
//     cl(pr.current)
    let i2=1
    for(let i=0;i<128;i++){
      let ci=pr.current.channelInfo[i]
//       cl(ci)
      let eqOnOff=constant.EQ_ONOFF
      let eqVent=constant.EQ_VENT
      if(is800){
        eqOnOff=constant.EQ_800_ON_OFF
        eqVent=constant.EQ_800_VENT
      }
      let show=(((!isPearl)&&ci.used)||pChans.includes(i))&&
        ([eqOnOff,eqVent].includes(+ci.channelType))
      show=show&&!(is800&&proportionals800.includes(ci.channelType)&&(i%2))
      if(show){
//         (this.gwType==1900))&&([constant.EQ_ONOFF,constant.EQ_VENT].includes(+ci.channelType))){
//         cl(ci)
        let pids=(ci.channelType==eqOnOff)?stagePids.onoPids:stagePids.ventPids
//         cl(pids)
//         cl(dbVals.z[this.zone][i])
        let vals=pids.slice(6-this.heatStages,+this.coolStages+7)
          .map(id=>{return (id<0)?-1:+(dbVals.z[this.zone][i][id]||0)})
        chans.push({
          ch:i,
          chId:(isPearl||is800)?1+i:i2++,
          type:ci.channelType,
          name:ci.channelName||"None",
          stages:vals,
          refs:vals.map(v=>{return React.createRef()}),
        })
      }
    }
    cl("loadStageData done")
    const chansWithoutRefs = chans.map(ch => ({
    ch: ch.ch,
    chId: ch.chId,
    type: ch.type,
    name: ch.name,
    stages: ch.stages,
    totalHeatStages: this.heatStages,
    totalCoolStages: this.coolStages,
  }))
    globs.tempStagesInfo = {equipments : chansWithoutRefs, siteId: this.zi.siteId, gwType: this.zi.gatewayType, controllerId: this.zi.controllerId?? "", virtual: this.props.current.virtual?? false};
    globs.events.publish("tempStagesLoaded", chansWithoutRefs);
    cl(chans)
    
    let eqOnOff=(this.gwType==800)?constant.EQ_800_ON_OFF:constant.EQ_ONOFF
    // cl(st.chans[2])
    chansWithoutRefs.forEach(ch=>{
      let pidBase=6-this.props.current.heatStages
      // cl(pidBase)
      let pids=(ch.type==eqOnOff)?stagePids.onoPids:stagePids.ventPids
      // cl(pids)
      ch.stages.forEach((st,i)=>{
        if(pids[i+pidBase]>=0){
          parms.push({
            z:this.zone,
            c:ch.ch,
            t:getTimeI(),
            f:1,
            i:pids[i+pidBase],
            d:st,
          })
        }
      })
    })
     
       cl("forai parms", parms)
       globs.tempStagesInfoparms =  parms
       globs.events.publish("tempStagesLoadedparms", parms);
    
    return chans
  }
  
  loadInfo=()=>{
    let st=this.state
    st.chans=this.loadStagesData()
    
    
//     this.setState({chans:chans})
  }
  
  getValue=(ind, val)=>{
  }
  
  showSaveCancel=()=>{
    return(
      <SaveCancel 
        onChange={(ind,val)=>this.onChange("saveCancel",val)}
        getValue={this.getValue}
        ind="0"
      />
    )
  }
  
  checkConflicts=(commonValues)=>{
//     cl(commonValues)
    if(!commonValues){return[]}
    let keys=Object.keys(commonValues)
    let len=commonValues[keys[0]].length
//     cl(len)
    let conflicts=Array.from({length:len},e=>false)
    let a0=commonValues[keys[0]]// values for first zone
    for(let i=1;i<keys.length;i++){
      let key=keys[i]
      if(key!="conflict"){
        let a=commonValues[keys[i]]
        a.forEach((v,i)=>{
          if(v!=a0[i]){conflicts[i]=true}
        })
      }
    }
//     cl(conflicts)
    return conflicts
  }

  localSave=()=>{// to return the data that shold be saved
    cl("localSave")
    globs.events.publish("saveOK",true)// so saving doesn't show
    return this.saveStagingData()
  }

  saveStagingData=(forai=false)=>{
    let parms=[]
    let st=this.state
    // cl(st)
    let stagePids=this.getStagePids()
    let eqOnOff=(this.gwType==800)?constant.EQ_800_ON_OFF:constant.EQ_ONOFF
    // cl(st.chans[2])
    st.chans.forEach(ch=>{
      let pidBase=6-this.props.current.heatStages
      // cl(pidBase)
      let pids=(ch.type==eqOnOff)?stagePids.onoPids:stagePids.ventPids
      // cl(pids)
      ch.stages.forEach((st,i)=>{
        if(pids[i+pidBase]>=0){
          parms.push({
            z:this.zone,
            c:ch.ch,
            t:getTimeI(),
            f:1,
            i:pids[i+pidBase],
            d:st,
          })
        }
      })
    })
    // cl(parms)
    // cl(this.props.current)
    // cl(this.zi.gatewayType,this.zi.controllerId)
    if(forai){
       globs.tempStagesInfoparms =  parms
       globs.events.publish("tempStagesLoadedparms", parms);
    }
    else
    if(this.props.groupInfo){return parms}// save is different for groups
    checkSendArray(parms,this.props.current.virtual,this.zi.gatewayType,
      this.zi.controllerId).then(r=>{globs.events.publish("saveOK",true)})
/* parms:
{
    c,d,f,i,t,z - s will be filled in
  }*/
  }
  
  onChange=(type,vals)=>{
    var updateChans=()=>{
      let chans=this.state.chans.slice(0)
      this.setState({chans:chans})
    }
    // cl(type,vals)
    switch(type){
      case "focus":
        vals.ch.focus=vals.st
        updateChans()
        break
      case "blur":
        vals.ch.focus=-1
        updateChans()
        break
      case "vent":
        if(!this.props.groupFwBlocked){globs.events.publish("savePageEnable",true)}
        if(this.props.groupFwBlocked){globs.events.publish("savePageEnable",false)}
        vals.ch.stages[vals.st]=vals.val
        this.changed=true
        updateChans()
        break
      case "ono":
        if(!this.props.groupFwBlocked){globs.events.publish("savePageEnable",true)}
        if(this.props.groupFwBlocked){globs.events.publish("savePageEnable",false)}
        vals.ch.stages[vals.st]=(vals.ch.stages[vals.st])?0:1
        this.changed=true
        updateChans()
        break
      case "saveCancel":
        switch(vals.value){
          case "save":
            // cl("save")
            this.saveStagingData()
//             this.saveCravoData()
            this.props.onChange(this.props.ind, vals)
            break
          default:
            break
        }
        break
    }
  }
  
  showChan=(ch,i)=>{
//     cl(ch)
//     cl(ch.focus)
//     cl(ch)
//     let colors=["#ab5555","#ab6755","#ab7855","#ab8955","#ab9a55","#abab55",
    let pr=this.props
    let colors=["#eb5555","#db5555","#cb5555","#bb5555","#ab5555","#ab7855",
    
      "#ababab","#55ab55","#55ab78","#55ab9a","#559aab","#5588cb","#5570eb"]
    let base=6-this.heatStages
    let col=colors[base+i]
//     cl(base+i)
    let name=ch.name||`Nam${ch.ch+1}`
    let eqOnOff=(this.gwType==800)?constant.EQ_800_ON_OFF:constant.EQ_ONOFF
//     let totStages=this.heatStages+this.coolStages+1;
//     cl(totStages)
    let refId=ch.stages.length*i
    return(
      <tr key={i}><td width="50">{ch.chId}</td><td>{name}</td>
      {ch.stages.map((st,j)=>{
//         cl(st)
        let col=colors[base+j]
        var val
        var cell
        var key
        if(this.ourKey){
          let parts=this.ourKey.split("-")
          parts[1]=groupPidArrs.VentStages[refId]
          key=parts.join("-")
        }
        if(ch.type==eqOnOff){
          // cl("onoff--------")
          val=(st)?"On":"Off"
          cell=(
            <>
              <button ref={ch.refs[j]}
              style={{backgroundColor:col,color:(st)?"white":"black",
                opacity:(st)?1.0:0.2
              }}
                  className={`date toggle ${(st)?"selected":""}`}
                  onClick={e=>{this.onChange("ono",{ch:ch,st:j})}}
              >
                {val}
              </button>
            </>
          )
          if(this.conflicts[refId+j]&&
            (!pr.orConflictOverrides.includes(key))){
//             cl("conflict")
            let control={
              cont:cell,
              ref:ch.refs[j],
              key:key,
              ind:pr.ind,
            }
            return (
            <td key={j}>
              {pr.commonValues.conflict(control,key,true)}
            </td>
            )
          }else{
            return <td key={j}>{cell}</td>
          }
        }else{
          // cl(" noelse onoff --------")
          val=(st<0)?"--":`${st}%`
          cell=(
            <>
            <input ref={ch.refs[j]} type="text"
              style={{width:58,backgroundColor:col,color:"white",}}
            value={(ch.focus==j)?st:val}
            disabled={st<0}
            onChange={e=>this.onChange("vent",{ch:ch,st:j,val:e.currentTarget.value})}
            onFocus={e=>this.onChange("focus",{ch:ch,st:j})}
            onBlur={e=>this.onChange("blur",{ch:ch,st:j})}
            />
            </>
          )
          if(this.conflicts[refId+j]&&
            (!pr.orConflictOverrides.includes(key))){
//             cl("conflict")
            let control={
              cont:cell,
              ref:ch.refs[j],
              key:key,
              ind:pr.ind,
            }
            return (
            <td key={j} style={{paddingBottom:10,}}>
              {pr.commonValues.conflict(control,key,true)}
            </td>
            )
          }else{
            return <td key={j} style={{paddingBottom:10,}}>{cell}</td>
          }
        }
      })}
      </tr>
    )
  }
  
  showStageHead=()=>{
    let heads=["Heat6","Heat5","Heat4","Heat3","Heat2","Heat1","Normal","Cool1","Cool2","Cool3",
      "Cool4","Cool5","Cool6"]
      let head2=heads.slice(6-this.heatStages,+this.coolStages+7)
      head2.unshift("Name")
      head2.unshift("Chan")
    return (
      <tr>
      {head2
//         let vals=pids.slice(6-this.heatStages,+this.coolStages+7)
        .map((h,i)=>{return <th key={i}><h3>{h}</h3></th>})}
      </tr>
    )
  }
  
  showChans=()=>{
    // cl(this.state.chans)
//     cl(window.innerWidth)
    let wid=0.54*window.innerWidth
    if(wid>1000){wid=1000}
    return(
      <div style={{width:"100%",overflowX:"auto"}}>
        <table><tbody>
        {this.showStageHead()}
        {this.state.chans.map((ch,i)=>this.showChan(ch,i))}
        </tbody></table>
      </div>
    )
  }
  
  render(){
    let c=this.state.chan
    return(
      <div
        title={(this.props?.rest?.parent||(e=>{}))({uri:"pid",pr:this.props})}
      >
      <h3>Equipment Temperature Stage Settings</h3>
      {this.showChans()}
      {this.showSaveCancel()}
      </div>
    )
  }
}

export default TempStaging00 ;
